import "./NoThanksButton.less";
import {Localize} from "@dp-instant/i18n";
import {Button, visibilityEffect} from "@dp-instant/ui";
import {IClickableComponentProps} from "@game/ui/interface/IClickableComponentProps";
import cn from "classnames";
import {playUIClickSound} from "@game/helpers";
import {hapticMedium} from "@game/haptic";

export const NoThanksButton = ({
    className,
    onClick,
    delay = 0
}: IClickableComponentProps & {delay: number}) => {
    const [invisible] = visibilityEffect(delay);

    return (
        <Button
            className={cn("no-thanks-button", className, {invisible})}
            onClick={() => {
                if (onClick) {
                    playUIClickSound();
                    hapticMedium();
                    onClick();
                }
            }}
        >
            {Localize.get("ui-win-continue", "CONTINUE")}
        </Button>
    );
};
